import { UIPortal } from "@solidwhite/ui-portal";
import { useTranslation } from "react-i18next";
import { powerrailsData } from "./PowerrailApplications";
import { useSnapshot } from "valtio";
import { powerrailstore } from "./powerrailstore";
import { useSpring, animated as a } from "@react-spring/web";
import store from "../../../../../appStore";
import { useSynchronizedState } from "@solidwhite/multiuser";

const vw = 100 / 1920;

const PowerrailUI = ({ visible = false, ...props }) => {
  // const { currentRail } = useSnapshot(powerrailstore);
  const [currentRail, setCurrentRail] = useSynchronizedState("c_powerrail", 0);
  const { sideBarToggle } = useSnapshot(store);

  const spring = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible
      ? sideBarToggle
        ? "translate(0%,0%)"
        : "translate(-15%,0%)"
      : sideBarToggle
        ? "translate(0%,100%)"
        : "translate(-15%,100%)",
  });

  return (
    <a.div
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        // width: "72vw",
        width: "100%",
        height: "25%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        opacity: spring.opacity,
        transform: spring.transform,
      }}
    >
      {powerrailsData.map((item, i) => (
        <PowerRailItem railId={item.id} textId={item.textId} key={`${item.id}_UIItem`} active={currentRail == i} railIndex={i} />
      ))}
    </a.div>
  );
};

const PowerRailItem = ({ railId = "", textId = "", railIndex = 0, active = false, ...props }) => {
  const [currentRail, setCurrentRail] = useSynchronizedState("c_powerrail", 0);

  const { t } = useTranslation();

  const spring = useSpring({
    backgroundColor: active ? "white" : "#3EBA7C",
  });

  const handleClick = () => {
    setCurrentRail(railIndex);
    // powerrailstore.currentRail = railIndex;
  };

  return (
    <a.div
      style={{
        height: `${40 * vw}vw`,
        backgroundColor: spring.backgroundColor,
        borderRadius: `${7 * vw}vw`,
        verticalAlign: "center",
        fontSize: `${15 * vw}vw`,
        color: "black",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        paddingLeft: `${45 * vw}vw`,
        paddingRight: `${45 * vw}vw`,
        margin: `${15 * vw}vw`,
        cursor: "pointer",
        pointerEvents: "auto",
        maxWidth: "18vw",
      }}
      onClick={handleClick}
    >
      {t(textId)}
    </a.div>
  );
};

export default PowerrailUI;
